import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { UpdateRoundInput } from "../../../__generated__/globalTypes";
import { UPDATE_ROUND } from "../rounds.queries";
import {
  UpdateRoundMutation,
  UpdateRoundMutationVariables,
} from "../../../__generated__/UpdateRoundMutation";
import { parseParams } from "../../../helpers/clean-object";
import { toast } from "react-toastify";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateRound = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateRoundInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateRoundMutation,
    UpdateRoundMutationVariables
  >(UPDATE_ROUND);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateRound?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateRound?.error ?? "Error");
        toast.error(
          "Une Erreur est survenue lors de la modification de la tournée"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
